var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_vm._t("content",function(){return [_c('i',{staticClass:"ion ion-file-tray-outline empty__icon"}),_c('p',[_vm._v(_vm._s(_vm.message || "No elements ere found."))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }